<template>
    <div v-if="isAuthenticated" class="button">
        <router-link
            v-show="navbar !== 'ProfilePage' && navbar !== 'None'"
            :to="{ name: 'AddCatch' }"
            title="Registrer fangst"
        >
            <img title="Registrer fangst" src="/images/btn-add-lk.svg" />
        </router-link>
        <router-link
            v-show="navbar === 'ProfilePage'"
            :to="{ name: 'AddCatcher' }"
            title="Registrer fisker"
        >
            <img title="Registrer fisker" src="/images/btn-add-lk.svg" />
        </router-link>
    </div>
</template>
<script>
import { mapState } from 'vuex';
import { Bus, Stops } from '../../common/bus';

export default {
    data() {
        return {
            navbar: 'CatchList',
        };
    },
    computed: {
        ...mapState('session', ['isAuthenticated']),
    },
    created() {
        Bus.$on(Stops.DATE_PARSED, this.onDateParsed);
        Bus.$on(Stops.NAVBAR, navbar => {
            this.navbar = navbar;
        });
    },
    beforeDestroy() {
        Bus.$off(Stops.NAVBAR, navbar => {
            this.navbar = navbar;
        });
    },
};
</script>
<style lang="scss" scoped>
.button {
    position: fixed;
    bottom: 1rem;
    right: 1rem;
}
img {
    width: 3rem;
    height: 3rem;
}
</style>
